import { ReactElement } from 'react'
import styled from 'styled-components'

import Heading from 'components/v2/Heading'
import { IRadioProps } from './types'

const Container = styled.label<{ disabled?: boolean }>`
  align-items: center;
  cursor: ${({ disabled }): string => (disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  gap: 8px;
`

const Input = styled.input`
  appearance: none;
  border: 1px solid #b0b0b0;
  border-radius: 50%;
  cursor: ${({ disabled }): string => (disabled ? 'not-allowed' : 'pointer')};
  height: 16px;
  margin: 0 0 0 5px;
  transition: 0.2s;
  width: 16px;
  min-width: 16px;

  &:hover {
    border: 1px solid #28265d;
  }

  &:checked {
    border: 5px solid #916ee8;
  }

  &:disabled {
    border-color: #e3e3e3;
  }
`

const RadioLabel = styled(Heading.Body)<{ noTextTransform?: boolean }>`
  text-transform: ${({ noTextTransform }): string => (noTextTransform ? 'none' : 'capitalize')};
`

const Radio = ({ children, noTextTransform = false, ...props }: IRadioProps): ReactElement => {
  return (
    <Container disabled={props.disabled}>
      <Input type="radio" {...props} />
      <RadioLabel noTextTransform={noTextTransform}>{children}</RadioLabel>
    </Container>
  )
}

export const RadioWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;

  input {
    margin-left: 0;
  }
`

export { Radio }
